export default __webpack_public_path__ + "static/media/newuser.6fc25b1f.svg";